import React from "react";
import { useLocation } from "react-router-dom";
import TableTitle from "src/components/home/TableTitle";
import MoreButton from "src/components/button/MoreButton";
import MoreButton2 from "src/components/button/MoreButton2";
import RankingTable from "src/components/table/RankingTable";
import SwipeButton from "src/components/button/SwipeButton";
import { formatStandardDate } from "src/utils/FormatUtil";

interface RankingBoardProps <T = {}> {
  contents: T[];
  date: string;
  isMore: boolean;
  handleLoadMore: () => Promise<void>;
}

const RankingBoard: React.FC<RankingBoardProps> = ({ contents, date, isMore, handleLoadMore }) => {
  const location = useLocation();
  
  return (
    <>
      <TableTitle 
        name="랭킹"
        date={formatStandardDate(date)}
        modalData={{
            title: "랭킹",
            content: [
            "스코어: 게시글수 30%, 열람율 30%, 구독자수 30%, 일자별 증감 10%로 책정하며 데일리 생성된 스코어의 1주일 평균",
            "카테고리: 텔레모아 자체 기준으로 구분"
            ]
        }} 
        tabs={["스코어", "구독자"]}
        type="/ranking"
        />
      <hr className="fullscreen-hr" />
      <SwipeButton type="/ranking" />
      {/* {SelectedCategory && <FilterButtons />} */}
      <RankingTable
        contents={contents}
      />
      {location.pathname === "/" ?<MoreButton path="/ranking" /> : isMore && <MoreButton2 onClick={handleLoadMore} />}
      </>
  );
};

export default RankingBoard;




